import BossModel from "@/models/BossModel";

export default class Passenger extends BossModel {

    static apiUrl = 'agent/reservation/passenger';

    static entity = 'agentReservationPassengers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_eid: this.number(),
            dossier_traveller_id: this.number(),
            agent_reservation_id: this.number(),
        }
    }
}
